import React, { useContext, useState } from "react";
import './Navbar.css';
import logo from '../Assets/logo.png';
import cart_icon from '../Assets/cart_icon.png';
import { Link } from "react-router";
import { ShopContext } from "../../Context/ShopContext";
import { FiMenu, FiX } from 'react-icons/fi';

const Navbar = () => {
  const [menu, setMenu] = useState("shop");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const { getTotalCartItems } = useContext(ShopContext);
  const token = localStorage.getItem('auth-token');

  const categories = {
    Férfi: ["Pólók", "Nadrágok", "Galléros pólók", "Pulóverek", "Ing", "Kabátok-Mellények", "Polár", "Formaruhák", "Táskák és kiegészítők", "Sport"],
    Női: ["Pólók", "Nadrágok", "Galléros pólók", "Pulóverek", "Ing", "Kabátok-Mellények", "Polár", "Formaruhák", "Táskák és kiegészítők", "Sport"],
    Gyerek: ["Pólók", "Galléros pólók", "Pulóverek", "Kabátok-Mellények", "Polár"],
    Kiegészítők: ["Baseball sapkák", "Cipők", "Frottír"]
  };

  const handleCategoryClick = (category) => {
    // ha már nyitva van, csukjuk be
    if (openSubmenu === category) {
      setOpenSubmenu(null);
    } else {
      setOpenSubmenu(category);
    }
  };
  

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="navbar">
      <div className="nav-top">
        <div className="nav-logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="hamburger-icon" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </div>
      </div>

      <ul className={`nav-menu ${mobileMenuOpen ? "open" : ""}`}>
        <li><Link to='/' className={menu === "shop" ? "active" : ""} onClick={() => setMenu("shop")}>Főoldal</Link></li>

        {Object.entries(categories).map(([mainCategory, subcategories]) => (
  <li
    key={mainCategory}
    className="nav-dropdown"
    onMouseEnter={() => !mobileMenuOpen && setMenu(mainCategory)}
    onMouseLeave={() => !mobileMenuOpen && setMenu("shop")}
  >
    <Link
      to="#"
      className={menu === mainCategory ? "active" : ""}
      onClick={(e) => {
        e.preventDefault();
        if (mobileMenuOpen) {
          handleCategoryClick(mainCategory);
        } else {
          setMenu(mainCategory);
        }
      }}
    >
      {mainCategory}
    </Link>

    {/* submenu csak akkor jelenik meg, ha desktopon hover vagy mobilon katt */}
    <ul
      className="nav-submenu"
      style={{
        display:
          (!mobileMenuOpen && menu === mainCategory) ||
          (mobileMenuOpen && openSubmenu === mainCategory)
            ? "block"
            : "none"
      }}
    >
      {subcategories.map(sub => (
        <li key={sub}>
          <Link to={`/category/${mainCategory}/${sub}`}>{sub}</Link>
        </li>
      ))}
    </ul>
  </li>
))}


        <li>
          <Link to='/kapcsolat' className={menu === "kapcsolat" ? "active" : ""} onClick={() => setMenu("kapcsolat")}>
            Kapcsolat
          </Link>
        </li>
      </ul>

      <div className="nav-login-cart">
        {token ? (
          <>
            <Link to='/profile'><button>Profilom</button></Link>
            <button onClick={() => { localStorage.removeItem('auth-token'); window.location.replace('/') }}>Kijelentkezés</button>
          </>
        ) : (
          <Link to='/login'><button>Bejelentkezés</button></Link>
        )}
        <Link to='/cart'><img src={cart_icon} alt="cart" /></Link>
        <div className="nav-cart-count">{getTotalCartItems()}</div>
      </div>
    </div>
  );
};

export default Navbar;
